import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ppra-trainings',
  templateUrl: './ppra-trainings.component.html',
  styleUrls: ['./ppra-trainings.component.scss']
})
export class PpraTrainingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}



